var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mb-5" }, [
    _c(
      "div",
      [
        _c(
          "div",
          [
            _c("img", {
              staticClass: "img-fluid rounded-3 d-block mx-auto",
              staticStyle: { "max-height": "300px", "object-fit": "contain" },
              attrs: {
                src: _vm.imageUrl(_vm.course.cover_photo),
                alt: "",
                loading: "lazy",
              },
            }),
            _vm._v(" "),
            _vm.slots.length
              ? _c("SlotPicker", {
                  staticClass: "mt-4",
                  attrs: { slots: _vm.slots, timezone: _vm.calendarTimezone },
                  model: {
                    value: _vm.chosenSlot,
                    callback: function ($$v) {
                      _vm.chosenSlot = $$v
                    },
                    expression: "chosenSlot",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex align-items-start mt-4" }, [
          _c("div", { staticClass: "fw-bold" }, [
            _vm._v("\n        " + _vm._s(_vm.course.title) + "\n      "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ms-auto text-nowrap" }, [
            (_vm.course.is_free || _vm.course.allow_student_to_set_price) &&
            !_vm.selectedOrderBumps
              ? _c("div", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm._f("price")(
                          _vm.course.finalPrice,
                          _vm.page.currency
                        )
                      ) +
                      "\n        "
                  ),
                ])
              : _vm.course.is_free && _vm.selectedOrderBumps
              ? _c("div", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm._f("price")(0, _vm.page.currency)) +
                      "\n        "
                  ),
                ])
              : _vm.course.price_variants
              ? _c("div", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm._f("price")(_vm.course.subtotal, _vm.page.currency)
                      ) +
                      "\n        "
                  ),
                ])
              : _c("div", [
                  _vm.priceDiff
                    ? _c("del", [
                        _vm._v(
                          _vm._s(
                            _vm._f("price")(_vm.course.price, _vm.page.currency)
                          )
                        ),
                      ])
                    : _c("span", { staticClass: "fw-bold" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm._f("price")(
                                _vm.course.price,
                                _vm.page.currency
                              )
                            ) +
                            "\n          "
                        ),
                      ]),
                ]),
          ]),
        ]),
        _vm._v(" "),
        _vm.course.checkout_description
          ? _c("div", {
              staticClass: "markdown mt-3",
              domProps: {
                innerHTML: _vm._s(_vm.snark(_vm.course.checkout_description)),
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("OrderBumps"),
        _vm._v(" "),
        _vm.course.multiple_licences || _vm.course.type === "physical"
          ? _c("MultipleLicences")
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showPromoCodeField,
                expression: "showPromoCodeField",
              },
            ],
          },
          [_c("PromoCode", { staticClass: "mb-3" })],
          1
        ),
        _vm._v(" "),
        _vm.course.type === "physical"
          ? _c(
              "div",
              { staticClass: "d-flex justify-content-between small mb-3" },
              [
                _c("div", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm._f("translate")("Shipping cost")) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm._f("price")(
                          _vm.chosenShippingTypeCost,
                          _vm.page.currency
                        )
                      ) +
                      "\n      "
                  ),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.priceDiff
          ? _c("div", { staticClass: "mt-3" }, [
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c("div", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm._f("translate")("Discount")) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ms-auto text-success fw-bold" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm._f("price")(_vm.priceDiff, _vm.page.currency)
                      ) +
                      "\n        "
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex align-items-end" }, [
          _c("div", { staticClass: "fw-bold" }, [
            _vm._v(
              "\n        " + _vm._s(_vm._f("translate")("Total")) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ms-auto h4 fw-bold mb-0" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm._f("price")(_vm.course.finalPrice, _vm.page.currency)
                ) +
                "\n      "
            ),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }